module.exports = {
  __init__: [
    'hoverFix'
  ],
  __depends__: [
    require(233)
  ],
  dragging: [ 'type', require(160) ],
  hoverFix: [ 'type', require(161) ]
};